'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactElement, type ReactNode } from 'react';
import DashboardFrame from 'shared/components/DashboardFrame';
import config from 'shared/config';
import { ClientProvider } from 'shared/context/ClientContext';
import { CopilotProvider } from 'shared/context/CopilotContext';
import { CopilotGlobalPageTools } from 'shared/copilot/components/CopilotGlobalPageTools';
import { MimirProvider } from 'shared/context/MimirContext';
import { FeatureFlagProvider } from 'shared/featureFlag/provider';
import { OverScreen } from 'shared/overScreens/niceModalReact';
const STATSIG_CLIENT_KEY = config('NEXT_PUBLIC_STATSIG_CLIENT_KEY') as string;
const DashboardLayout = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CopilotGlobalPageTools />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <ClientProvider><FeatureFlagProvider platformKey={STATSIG_CLIENT_KEY}><OverScreen.Provider><MimirProvider><CopilotProvider>{t1}<DashboardFrame>{children}</DashboardFrame></CopilotProvider></MimirProvider></OverScreen.Provider></FeatureFlagProvider></ClientProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default DashboardLayout;